class SaCartDrawerDiscount extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('[data-sa-discount-toggle]');
    this.panel = this.querySelector('[data-sa-discount-panel]');
    this.input = this.querySelector('[data-sa-discount-input]');
    this.applyBtn = this.querySelector('[data-sa-discount-apply]');
    this.errorEl = this.querySelector('[data-sa-discount-error]');
    this.mobileQuery = window.matchMedia('(max-width: 999px)');

    this.toggleBtn?.addEventListener('click', this.onToggle);
    this.applyBtn?.addEventListener('click', this.onApply);
    this.input?.addEventListener('keydown', this.onKeydown);
    this.mobileQuery.addEventListener('change', this.onViewportChange);

    if (this.mobileQuery.matches && this.panel?.hidden) {
      this.setOpen(true);
      this.dataset.saMobileAutoOpen = 'true';
    }
  }

  disconnectedCallback() {
    this.toggleBtn?.removeEventListener('click', this.onToggle);
    this.applyBtn?.removeEventListener('click', this.onApply);
    this.input?.removeEventListener('keydown', this.onKeydown);
    this.mobileQuery?.removeEventListener('change', this.onViewportChange);
  }

  onToggle = () => {
    if (!this.panel || !this.toggleBtn) return;

    const isOpen = this.classList.contains('is-open');
    delete this.dataset.saMobileAutoOpen;
    this.setOpen(!isOpen);
    if (!isOpen) this.input?.focus();
  };

  setOpen(isOpen) {
    if (!this.panel || !this.toggleBtn) return;
    this.panel.classList.toggle('hidden', !isOpen);
    this.panel.hidden = !isOpen;
    this.toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    this.classList.toggle('is-open', isOpen);
  }

  onViewportChange = (event) => {
    if (event.matches) {
      if (!this.classList.contains('is-open')) {
        this.setOpen(true);
        this.dataset.saMobileAutoOpen = 'true';
      }
      return;
    }

    if (this.dataset.saMobileAutoOpen === 'true') {
      this.setOpen(false);
      delete this.dataset.saMobileAutoOpen;
    }
  };

  onKeydown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.onApply();
    }
  };

  setError(message) {
    if (!this.errorEl) return;
    if (!message) {
      this.errorEl.textContent = '';
      this.errorEl.classList.add('hidden');
      return;
    }
    this.errorEl.textContent = message;
    this.errorEl.classList.remove('hidden');
  }

  onApply = async () => {
    const code = (this.input?.value || '').trim();
    if (!code) {
      this.setError('Please enter a discount code.');
      return;
    }

    this.setError('');
    if (this.applyBtn) this.applyBtn.disabled = true;

    try {
      const response = await fetch(`/discount/${encodeURIComponent(code)}`, {
        method: 'GET',
        credentials: 'same-origin',
      });

      if (!response.ok && response.status >= 500) {
        throw new Error('Unable to apply discount code.');
      }

      const cartUrl = window.routes?.cart_url || '/cart';
      const sectionResponse = await fetch(
        `${cartUrl}?section_id=cart-drawer&sections_url=${encodeURIComponent(window.location.pathname)}`,
      );
      const sectionText = await sectionResponse.text();
      const doc = new DOMParser().parseFromString(sectionText, 'text/html');
      const source = doc.querySelector('#CartDrawer');
      const target = document.getElementById('CartDrawer');
      if (source && target) {
        target.innerHTML = source.innerHTML;
        document.querySelector('sa-cart-drawer-recommendations')?.load?.();
      }
    } catch (error) {
      this.setError(error.message || 'Unable to apply discount code.');
    } finally {
      if (this.applyBtn) this.applyBtn.disabled = false;
    }
  };
}

if (!customElements.get('sa-cart-drawer-discount')) {
  customElements.define('sa-cart-drawer-discount', SaCartDrawerDiscount);
}
